import { rootApi } from "@/services/api/api";
import type {
  AccessPinCodeRequest,
  AccessPinCodeResponse,
  ChangePinCodeRequest,
  ChangePinCodeResponse,
  CreatePinCodeRequest,
  CreatePinCodeResponse,
} from "../types";

const pinCodeApi = rootApi.injectEndpoints({
  endpoints: (build) => ({
    changePinCode: build.mutation<ChangePinCodeResponse, ChangePinCodeRequest>({
      query: (body) => ({
        url: "/pin/change",
        method: "POST",
        body,
      }),
      invalidatesTags: ["pinCode"],
    }),
    createPinCode: build.mutation<CreatePinCodeResponse, CreatePinCodeRequest>({
      query: (body) => ({
        url: "/pin",
        method: "POST",
        body,
      }),
      invalidatesTags: ["pinCode"],
    }),
    accessPinCode: build.mutation<AccessPinCodeResponse, AccessPinCodeRequest>({
      query: (body) => ({
        url: "/pin/access",
        method: "POST",
        body,
      }),
      invalidatesTags: ["pinCode", "authStatus"],
    }),
  }),
});

export const { useChangePinCodeMutation, useAccessPinCodeMutation, useCreatePinCodeMutation } =
  pinCodeApi;
